export default __webpack_public_path__ + "static/188-c3ebebf360bcfa7ea152465ab8ec8fc4.jpg";